/**
 * interact.js v1.3.0-alpha.3+sha.9595c40
 *
 * Copyright (c) 2012-2017 Taye Adeyemi <dev@taye.me>
 * Open source under the MIT License.
 * https://raw.github.com/taye/interact.js/master/LICENSE
 */
